// extracted by mini-css-extract-plugin
export default {"container":"PublicRoutes_container__0zZky"};